import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 0 0-2 0v4H6a1 1 0 0 0-1 1c0 4.08.756 6.64 2.132 8.169 1.126 1.25 2.537 1.67 3.868 1.79V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1c-1.41 0-2.546-.24-3.382-1.169-.796-.885-1.485-2.573-1.6-5.831h9.965c-.121 3.39-.861 5.079-1.698 5.934a1 1 0 0 0 1.43 1.399C18.188 14.826 19 12.227 19 8a1 1 0 0 0-1-1h-2V3a1 1 0 1 0-2 0v4h-4z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_charge-BrvSNe0e.js.map
